<template>
    <div class="list" @click="goDetail(item.id)">
        <!-- <img class="list-img" v-lazy="item.image" /> -->
        <el-image class="list-img" fit="cover" :src="item.image" >
        </el-image>
         <!-- <div class="img" v-lazy:backgroundImage = item.image></div> -->
        <div class="list-right">
            <h3 class='title'>{{item.houseno}}</h3>
            <span  class="marker" v-for="(item,index) in item.activity" :key="index">{{item}}</span>
            <ul>
                <li v-if="item.architecture"><span>建筑：</span>{{item.architecture}}</li>
                <div style="display:flex;">
                    <li style="flex:0.5" v-if="item.bedrooms"><span>卧室数量：</span>{{item.bedrooms}}</li>
                    <li style="flex:0.5" v-if="item.bathroom"><span>卫浴数量：</span>{{item.bathroom}}</li>
                </div>
            </ul>
            <div class="city-area">
                <div class="money" v-if="item.features"><span>租金包含：</span>{{item.features}}</div>
                <div class="money" v-if="item.cityarea"><span>区域：</span>{{item.cityarea}}</div>
            </div>
            <div class="local" v-if="item.college && item.college.length != 0"><img style="width:1.8rem;height:1.4rem;" :src="local_icon"/><i v-for="(item) in item.college" :key="item.id">{{item}}</i></div>
        </div>
        <div class="vr-video">
            <div class="icon-button" v-if="item.vr" @click.stop="openVr(item.vr)"><img :src="vr_icon" /><span>VR</span></div>
            <!-- <div class="icon-button" ><img :src="video_icon" /><span>视频</span></div> -->
        </div>
    </div>
</template>
<script>
import local_icon from '@assets/image/rent/local-icon.png'
import vr_icon from '@assets/image/rent/vr_icon.png'
import video_icon from '@assets/image/rent/video_icon.png'

export default {
    name: 'RentList',
    computed:{

    },
    props:{
        item:{
            type:Object,
            required: true
        }
    },
    components: {

    },
    data(){
        return {
            local_icon,vr_icon,video_icon
        }
    },
    mounted(){

    },
    methods:{
        goDetail(id){
            window.open('/aparmentDetail?id='+id, '_blank')
        },
        openVr(url){
            window.open(url,'_blank')
        }
    }

}
</script>
<style lang="scss" scoped>
.list{
    display: flex;
    padding: 2rem 0;
    cursor: pointer;
    border-bottom: solid 1px #d8d8d8;
    position: relative;
}
.list-img{
    width: 21rem;
    height: 14rem;
}
.list-right{
    padding-left: 2.2rem;
    .title{
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 1.8rem;
        margin-bottom:1.2rem;
        color: #0e2d57;
    }
    .marker{
        display: inline-block;
        padding: 0 1.1rem;
        height: 1.3rem;
        line-height: 1.3rem;
        color: #3a4a5b;
        margin-right: 1rem;
        margin-bottom: 0.5rem;
        background-color: #d1dbe6;
        border-radius: 4px;
        border: solid 1px #0e2d57;
    }
    ul{
        display: flex;
        padding-top:0.8rem;
       li{
            font-size: 1.0rem;
            color: #3a4a5b;
            margin-right: 3rem;
           span{
                font-weight: 700;
                line-height: 2rem;
                letter-spacing: 0px;
                color: #3a4a5b;
           }
        
       } 
    }
    .money{
            font-size: 1.0rem;
            color: #3a4a5b;
            margin-right: 2rem;
        span{
            font-weight: 700;
            line-height: 2rem;
            letter-spacing: 0px;
            color: #3a4a5b;
        }
    }
    .local{
        margin-top:1.5rem;
        font-size: 1rem;
        letter-spacing: 0px;
        color: #3a4a5b;
        i{
            margin-left: 0.9rem;
        }
    }
}
.vr-video{
    position: absolute;
    display: flex;
    top: 2.9rem;
    left: 1.4rem;
    color: #fff;
    cursor: pointer;
    font-size: 0.7rem;
    .icon-button{
        width: 3.8rem;
        height: 1.5rem;
        line-height: 1.5rem;
        background-color:rgba(14, 45, 87,0.5);
        border-radius: 6px;
        margin-right:0.5rem;
        align-items: center;
        display: flex;
        img{
            width: 0.9rem;
            height: 0.9rem;
            display: block;
            margin: 0 0.5rem;
        }
    }
}
.city-area{
    display: flex;
}
@media only screen and (max-width: 1024px){
    .list-img{
        width: 100%;
        height: auto;
    }
    .list-right{
        padding-left: 1rem;
        ul{
            display: block;
            padding-top: 0;
        }
        .title{
            margin-top: 1rem;
            margin-bottom: 0.6rem;
        }
        .local{
            margin-top: 0.5rem;
        }
    }
}
</style>